import { useQuery } from 'react-query';
import axiosInstance from '../../helpers/axiosInstance';
import { QueryKeys } from '../QueryKeys';

export const usePatientPendingAgreements = ({ patientId }: { patientId: string | undefined }) => {
  return useQuery<string[]>(
    QueryKeys.patientPendingAgreements(patientId),
    async () => {
      return axiosInstance
        .get<{ agreements: string[] }>(`/patients/patients/${patientId}/pending_agreements`)
        .then((r) => r.data?.agreements || []);
    },
    { enabled: !!patientId },
  );
};
